import {Context} from 'react'
import {typedConnect} from '../../../../../commons/components/runtime-context/connect'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {AppProps} from '../../types/props'

export const WidgetRuntimeContext: Context<AppProps> = RuntimeContext

export const connect = typedConnect<AppProps>()
